export default function parseFragmentForRemoveEl(documentFragment) {
  if (documentFragment.children.length === 0 && documentFragment.firstChild) {
    let textEl = documentFragment.firstChild;
    const text = textEl.textContent || '';
    const spanNode = document.createElement('span');
    spanNode.innerText = text;
    spanNode.className = 'removed';
    documentFragment.removeChild(textEl);
    documentFragment.append(spanNode);
  } else {
    Array.from(documentFragment.children).forEach((node) => {
      if (node.nodeName === 'P') {
        const spanNode = document.createElement('span');
        spanNode.innerText = node.innerText;
        spanNode.className = 'removed';
        node.innerText = '';
        node.appendChild(spanNode);
      } else if (node.nodeName === 'IMG' || node.nodeName === 'IFRAME') {
        node.className = 'removed-img';
      } else {
        parseFragmentForRemoveEl(node);
      }
    });
  }
  return documentFragment;
}



// WEBPACK FOOTER //
// ./app/javascript/client/editor-core/utils/parseFragmentForRemoveEl.js